import * as api from "../../helpers/api_helper";
import { GET_CARRIERS } from "../../helpers/url_helper";

export const getCarriers = () => api.get(GET_CARRIERS);
export const getAllCarriersCombo = () => api.get(GET_CARRIERS+"/GetAllCombo");